import { USE_API_MOCKS } from '../env';
import { API_URL } from '@api/apiDictionary';
import { RESTClient, RESTClientMock } from '@api/client';

import { User, UserRequest } from '@dynamika-shared/types/users';
import {
  PaginatedArgs,
  PaginatedResponse,
} from '@dynamika-shared/types/general';
import { UserRoles } from '@dynamika-shared/types/auth';
import { OrganizationType } from '@dynamika-shared/types/inventory';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export type UserRequestArgs = PaginatedArgs & {
  filter?: string;
  organizationId?: string;
  role?: UserRoles;
  enabled?: boolean;
};

export const fetchUsersList = (args: UserRequestArgs) => {
  return api.get<PaginatedResponse<User>>(API_URL.userManagement, {
    params: {
      ...args,
      page: args?.page ? args?.page - 1 : 0,
      size: args?.size ?? 10,
    },
  });
};

export const fetchUsersInstitution = () => {
  return api.get<OrganizationType[]>(API_URL.userManagementInstitution);
};
export const createUser = (user: UserRequest) => {
  return api.post(API_URL.userManagement, user);
};
export const updateUser = (user: UserRequest, id: string) => {
  return api.put(`${API_URL.userManagement}/${id}`, user);
};

export const deactivateUser = (id: string) => {
  return api.post(`${API_URL.userManagementDeactivate.replace(':id', id)}`);
};

export const reactivateUser = (id: string) => {
  return api.post(`${API_URL.userManagementReactivate.replace(':id', id)}`);
};

export const resendInvitation = (id: string) => {
  return api.post(`${API_URL.userManagementResendInvitation.replace(':id', id)}`);
};
